import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices
import categoryReducer from "./slices/Category";
import ServiceReducer from "./slices/Service";

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const categoryPersistConfig = {
  key: "category",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};
const servicePersistConfig = {
  key: "service",
  storage,
  keyPrefix: "redux-",
};
const rootReducer = combineReducers({
  category: persistReducer(categoryPersistConfig, categoryReducer),
  service: persistReducer(servicePersistConfig, ServiceReducer),
});

export { rootPersistConfig, rootReducer };
